<template>
  <div class="video-thumb">
      <div class="video-thumb__content">
      <div class="d-flex avatarBox mt-2">
        <AvatarComponent
          :url="vlog.profile.picture"
          size="38"
        />
        <HeaderThumb :vlog="vlog"/>
      </div>
    </div>

    <v-img
      :src="video && video.thumbUrl ? video.thumbUrl : srcThumb"
      class="pointer mt-3"
      height="180px"
      @click="openVideoPage()"
    >
      <div class="d-flex align-center justify-center fill-height">
        <div class="buttons">
          <v-btn color="rgba(255,255,255,.6)" fab icon>
            <v-icon size="73">fal fa-circle-play</v-icon>
          </v-btn>
        </div>
      </div>
    </v-img>
  </div>
</template>

<script>
import HeaderThumb from "@/components/Thumbnails/HeaderThumb";
export default {
  name: 'VideoThumb',
  props: {
    srcThumb: String,
    vlog: Object,
    video: Object,
    meta: {
      type: Object,
      default: {}
    },
    isLinkToDetailPost: {
      type: Boolean,
      default: false
    }
  },
  components: {
    HeaderThumb
  },
  methods: {
    openVideoPage() {
      if(this.vlog.id && this.isLinkToDetailPost) {
        this.$emit('linkToDetailPost', this.vlog.id)
      } else this.$emit("openDialogDetail", this.vlog || null);
    },
    gotoChannel() {
      window.location.href = `https://www.youtube.com/channel/${this.meta.channelId}`;
    },
  },
};
</script>